import { h } from 'preact'
import Switcher from '../control/Switcher'
import {
  ActionButtons,
  HowToTextWithOpenInNewTabIcon,
  InformationCallout,
  PanelHeaderWithIcon
} from './PanelItems'

interface BodyProps {
    isRegistrationApprovalEnabled: boolean,
    showRegistrationApprovalActionButtons: boolean,
    onSave: () => void,
    onCancel: () => void,
    onRegistrationApprovalChanged: (value: boolean) => void
}

export const RegistrationApprovalPanelBody = ({ isRegistrationApprovalEnabled, showRegistrationApprovalActionButtons, onSave, onCancel, onRegistrationApprovalChanged } : BodyProps) => (
  <div className='panel-body-container'>
    <InformationCallout text='By default, new registered users can create topics and reply after they activated their account.' />
    <div>
      <Switcher
        on={isRegistrationApprovalEnabled}
        customClass='panel-switch'
        label='New registered users must be approved by moderators. A user can only create topics and reply after approval.'
        onChange={() => onRegistrationApprovalChanged(!isRegistrationApprovalEnabled)} />
    </div>
    <HowToTextWithOpenInNewTabIcon
      label='How to approve new registrations'
      url='https://community.insided.com/registration-login-preferences-sso-88/how-to-enable-moderator-approval-of-new-registrations-501' />
    { showRegistrationApprovalActionButtons &&
    <ActionButtons
      onSave={() => onSave()}
      onCancel={() => onCancel()} />
    }
  </div>
)

interface HeaderProps {
    statusText: string
}

export const RegistrationApprovalPanelHeader = ({ statusText } : HeaderProps) => (
  <PanelHeaderWithIcon
    customClass='panel-header-container'
    iconCustomClass='icon-panel-header'
    icon='checkUserRegistration'
    title='Registration approvals'
    statusText={statusText} />
)
